import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";
import { ExpandLess } from "@material-ui/icons";
import { mediaReleases } from "../../../resources/images";
import { endUserActions } from "../../../store/endUser/endUserActions";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
  },
  headingWrapper: {
    backgroundColor: "#E5F2FF !important",
  },
  heading: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#000",
    display: "flex",
    alignItems: "center",
  },
  svgIcon: {
    marginRight: "11px",
  },
  expanded: {
    backgroundColor: "rgba(24, 103, 185, 0.08)",
  },
  links: {
    flexDirection: "column",
    paddingBottom: "0",
  },
  boxes: {
    boxShadow: "none",
  },
  hyperLink: {
    marginLeft: "15px",
    textDecoration: "none",
    marginBottom: "12px",
    color: "#8D99A5",
    fontSize: "14px",
    fontWeight: "500",
    letterSpacing: ".2px",
    "&:hover": {
      color: "#3699FF",
    },
  },
  activeTest: {
    color: "#3699FF",
  },
}));

export default function SupportNav() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { panel } = useSelector(state => state.endUserReducer);
  const [expanded, setExpanded] = useState(panel);
  const { id } = useParams();
  const history = useHistory();
  const currentRoot = history ? history.location.pathname : null;

  useEffect(() => {
    if (
      [
        "/support-faq",
        "/new-faq",
        `/new-faq/${id}`,
      ].includes(currentRoot)
    ) {
      setExpanded("panel1");
      dispatch(endUserActions.onChange("panel", "panel1"));
    }
  }, []);

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    dispatch(endUserActions.onChange("panel", panel));
  };

  return (
    <div className='subNavWrapper'>
      <h1>Support</h1>
      <div className={classes.root}>
        <Accordion
          className={classes.boxes}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}>
          <AccordionSummary
            expandIcon={<ExpandLess />}
            aria-controls='panel1a-content'
            id='panel1a-header'
            //className='headingWrapper'
            className={
              [
                "/support-faq",
                "/new-faq",
                `/new-faq/${id}`,
              ].includes(currentRoot)
                ? classes.headingWrapper
                : null
            }>
            <Typography className={classes.heading}>
              <img src={mediaReleases} alt='products' className='releaseIcon' />
              FAQs
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.links}>
            <Link
              to='/support-faq'
              className={`${classes.hyperLink} ${
                [
                    "/support-faq",
                    "/new-faq",
                    `/new-faq/${id}`,
                ].includes(currentRoot)
                  ? classes.activeTest
                  : null
              }`}
            >
              FAQs
            </Link>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
